import React from 'react';
import ListingPreview from '../ListingPreview';
import './styles.scss';

const component = ({ items }) => {
  return (
    <fieldset className="listings-preview-group">
      {items.map((listing) => (
        <ListingPreview key={listing.id} {...listing} />
      ))}
    </fieldset>
  );
};

component.displayName = 'ListingPreviewGroup';
export default component;



// WEBPACK FOOTER //
// ./client/components/ListingPreviewsGroup/index.js